import React from "react";
import * as Yup from "yup";
import { useDispatch } from "react-redux";
import { useFormik } from "formik";
import {
  AddLanguageAction,
  UpdateLanguageAction,
} from "store/middlewares/dataManagement/language";

import {
  Button,
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  Input,
  Label,
} from "components/ui";

function ModalEditLanguage({ row }) {
  const dispatch = useDispatch();

  // const AddSpecialitySchema = Yup.object({
  //   language: Name,
  // });

  const handleSubmit = (values) => {
    if (row) {
      dispatch(UpdateLanguageAction({ id: row.id, ...values }));
    } else {
      dispatch(
        AddLanguageAction({ ...values, filter: { page: 1, pageSize: 10 } })
      );
    }
  };

  const formik = useFormik({
    initialValues: {
      name: row?.name ? row?.name : "",
      code: row?.code ? row?.code : "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Language name is required"),
      code: Yup.string()
        .required("Language code is required")
        .min(2, "Language code should be at least 2 characters"),
    }),
    enableReinitialize: true,
    onSubmit: handleSubmit,
  });

  return (
    // <form onSubmit={formik.handleSubmit}>
    //   <Input
    //     inputClassName="rounded-lg w-full px-2 py-2 mt-2"
    //     label={"Name"}
    //     error={formik.errors.name && formik.touched.name}
    //     errorMsg={formik.errors.name}
    //     value={formik.values.name}
    //     type="text"
    //     name="name"
    //     onChange={formik.handleChange}
    //     onBlur={formik.handleBlur}
    //     placeholder="Enter Language"
    //   />
    //   <Input
    //     inputClassName="rounded-lg w-full px-2 py-2 mt-2"
    //     label={"Code"}
    //     error={formik.errors.code && formik.touched.code}
    //     errorMsg={formik.errors.code}
    //     value={formik.values.code}
    //     type="text"
    //     name="code"
    //     onChange={formik.handleChange}
    //     onBlur={formik.handleBlur}
    //     placeholder="Enter Code"
    //   />
    //   <div className="flex justify-end pt-5">
    //     <Button type={"submit"} size={"lg"}>
    //       {row ? "Update" : "Add"}
    //     </Button>
    //   </div>
    // </form>
    <form onSubmit={formik.handleSubmit}>
      <div className="grid gap-5 lg:gap-7.5 mx-auto">
        <Card className="min-w-full">
          <CardHeader>
            <CardTitle>Language</CardTitle>
          </CardHeader>
          <CardContent className="grid gap-5">
            <div className="flex items-baseline flex-wrap lg:flex-nowrap gap-2.5">
              <Label className="flex w-full max-w-56">Name</Label>
              <Input
                error={formik.errors.name && formik.touched.name}
                errorMsg={formik.errors.name}
                value={formik.values.name}
                type="text"
                name="name"
                maxLength={50}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                isTextOnly={true}
                placeholder="Enter Language"
                className={"!py-0 w-full"}
              />
            </div>
            <div className="flex items-baseline flex-wrap lg:flex-nowrap gap-2.5">
              <Label className="flex w-full max-w-56">Code</Label>
              <Input
                error={formik.errors.code && formik.touched.code}
                errorMsg={formik.errors.code}
                value={formik.values.code}
                type="text"
                name="code"
                isTextOnly={true}
                suggestions="off"
                maxLength={5}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                placeholder="Enter Code"
                className={"!py-0 w-full"}
              />
            </div>
            <div className="flex justify-center">
              <Button type={"submit"}>{row ? "Update" : "Add"}</Button>
            </div>
          </CardContent>
        </Card>
      </div>
    </form>
  );
}

export default ModalEditLanguage;
